const other1 = `
&lt;div v-loading="loadingStatus">&lt;/div>
 `
const other2 = `
wx.showLoading({
    title: '加载中'
})

wx.hideLoading()
 `

export default {
    other1,
    other2
}